$.ajaxPrefilter(function(options, originalOptions, xhr) { // this will run before each request
    var token = $('meta[name="csrf-token"]').attr('content'); // or _token, whichever you are using
    if (token) {
        return xhr.setRequestHeader('X-CSRF-TOKEN', token); // adds directly to the XmlHttpRequest Object
    }
});
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});



$.fn.lockForm = function() {
    var params = $(this).serializeArray();
    $(this).find('input, textarea').attr('disabled', true);
    $(this).find('input[type=submit], button[type=submit]').hide();
    $(this).find('.loader').show();
    return params;
};

$.fn.unlockForm = function() {
    $(this).find('input, textarea').attr('disabled', false);
    $(this).find('input[type=submit], button[type=submit]').show();
    $(this).find('.loader').hide();
};

var confirmPost = window.confirmPost = function(message, url){
    if(confirm(message)){
        var token = $('meta[name="csrf-token"]').attr('content');
        $('<form method="post" action="'+url+'"><input name="_token" value="' + token + '"></form>').appendTo('body').submit();
    }
};



(function () {
    if ( typeof NodeList.prototype.forEach === "function" ) return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();


var isMobile = window.isMobile = function isMobile(){
    var el = document.getElementById('is-mobile');
    var style = window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle;
    return style.display == 'none';
}


if(!isMobile()) {
    if(document.fonts){
        document.fonts.ready.then(fixLeads);
    } else {
        document.addEventListener('DOMContentLoaded', fixLeads);
    }
}



$.fn.miselect = function(url, onChange)  {
    var select = $(this);
    select.selectize({
        create: false,
        maxItems: 1,
        preload: true,
        // allowEmptyOption: true ,
        // sortField: 'text',
        // options: [{value:1,text:'jeden'}, {value:2,text:'dwa'}, {value:3,text:'trzy'}],
        load: function(query, callback) {
            // if (!query.length) return callback();
            $.get(url, {query: query}, function(res){
                callback(res);
                //callback(res.repositories.slice(0, 10));
            });
        },
        onChange: function(value){
            if(onChange){
                var tmp = select[0];
                var text = tmp.options[tmp.selectedIndex].text;
                onChange(value, text);
            }
        },
        onFocus: function(){
            // if(!this.getValue()){
            //
            // }
            this.$control.parent().parent().find('label').addClass('focus');
        },
        onBlur: function(){
            this.$control.parent().parent().find('label').removeClass('focus');
        },
    });
}



function fixLeads(doc)  {
    if(doc.querySelector == undefined){
        doc = document;
    }
    var headerLineHeight = 34.5;
    var leadLineHeight = 24;

    function fix(art, totalLines, callback){
        totalLines = art.dataset.lines || totalLines;
        var headline = art.querySelector('h2');
        var lead = art.querySelector('.lead');

        if(lead.classList.contains('no-scale')){
            return;
        }
        var headerLines = Math.round(headline.clientHeight / headerLineHeight);


        var leadLines = totalLines - headerLines;
        leadLines = Math.max(leadLines, 0);
        var newHeight = leadLines * leadLineHeight;

        lead.style.webkitLineClamp = leadLines;
        lead.style.maxHeight = newHeight + 'px';

        if(lead.clientHeight < newHeight - leadLineHeight / 2) {
            lead.innerHTML = lead.dataset.long;
        }

        callback(headline, lead, headerLines);
    }

    var articles = doc.querySelectorAll('.article.tablet-horizontal');
    articles.forEach(function(art){
        fix(art, 6, function(headline, lead, headerLines){
            if(headerLines > 2){
                headline.style.lineHeight = '1.13'; // -3
                //headline.style.marginBottom = '10px'; // -3
                fix(art, 6, function(){}) ;
            }
        });
    })

    var articles = doc.querySelectorAll('.article.tablet-vertical');
    articles.forEach(function(art){
        fix(art, 6 , function(headline, lead, headerLines){
           if(headerLines > 2){
               if(! headline.classList.contains('title-small-desktop')){
                   headline.style.lineHeight = '1.13'; // -3
                   fix(art, 6, function(){}) ;
               }
               // headline.style.marginBottom = '10px'; // -3
           }
        });
    })
}

window.fixLeads = fixLeads;

var fixForumLead = window.fixForumLead = function () {
    // var elements = document.querySelectorAll('#forum-list li');
    // elements.forEach(function(el){
    //     var title = el.querySelector('.title');
    //     var lead = el.querySelector('.small');
    //
    //     console.log(title.clientHeight);
    //     if(title.clientHeight > 30 ) {
    //         lead.style.webkitLineClamp = 2;
    //         lead.style.maxHeight = 2 * 20 + 'px';
    //     }
    // });
}

var openShare = window.openShare =  function(url) {
    var width = 600,
        height = 400,
        left = (screen.width / 2) - (width / 2),
        top = (screen.height / 2) - (height / 2);
    window.open(
        url,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
    );
};

var initNews  = window.initNews = function(){
    // comment link
    var comLink = document.querySelector('.com-link');
    comLink.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('#comments-section').scrollIntoView({ block: 'start',  behavior: 'smooth' });
        // alert('click');
    })


    //share links
    $('.fb-link, .tw-link, #fb-share-btn').click(function(){
        openShare($(this).attr('href'));
        return false;
    });

    //document.getElementsByClassName('comments').scrollIntoView({ block: 'end',  behavior: 'smooth' });

    var initCaptions = function(){
        var imgs = $('.news .con img');
        $.each(imgs, function(){
            var img = $(this);
            var title = img.attr('title');
            if(title){
                var figure = $('<figure></figure>').attr('class', img.attr('class'));

                img.replaceWith(figure);
                img.attr('class', '');
                figure.append(img);
                figure.append('<figcaption>' + title +'</figcaption>');

                img.one('load',function() {
                    figure.css('max-width', img.width());
                    console.log('after-load');
                });
            }
        });
    }
    initCaptions();


    $('#stats_link a').click(function(){
        var span = $('<span>Pobieranie...</span>');
        $(this).replaceWith(span);
        $.post('/admin/analytics/stats', {url: window.location.pathname}, function(data){
            span.text(data);
        });
        return false;
    });

}


var initFbLikes = window.initFbLikes = function(doc){
    doc = doc || document;

    var baseUrl = 'https://miasto-info.pl'; //window.location.href.slice(0,-1);
    var urls = [];
    var els = $(doc).find('.fb-stats');
    $.each(els, function(){
        urls.push(baseUrl + $(this).data('url'));
    });

    getFbStats(urls,function(stats){
        $.each(els, function(i){
            var num = parseInt(stats[i]);
            if(num || !$(this).data('hide-zero')){
                $(this).append(num);
                $(this).show();
            }
            // if(stats[i]){
            //
            // }
        });
    });
}

var getFbStats = function(urls, callback){
    urls.forEach(function(item, i){
        urls[i] = encodeURIComponent(encodeURIComponent(item));
    });

    $.get('/facebook-likes?ids=' + urls.join(','), function(data){
        // console.log(data, Object.values(data));
        callback(Object.values(data));
    })
}

var getFromFb = function(requestUrls, urls, ret, callback) {
    requestUrls = requestUrls.join(',');
    var apiUrl = "//graph.facebook.com/v2.2/?ids=" + requestUrls;
    apiUrl += "&fields=og_object{engagement}";
    $.ajax({
        url: apiUrl,
        dataType: 'jsonp',
        success: function(data){
            // console.log(data);
            if(data){
                $.each( data, function(responseUrl, v){
                    if(v.og_object && v.og_object.engagement && v.og_object.engagement.count ){
                        var count = v.og_object.engagement.count;
                    } else {
                        var count = 0;
                    }
                    var responseUrl = responseUrl.replace('%2C', ',').replace('https:', '').replace('http:', '');
                    var index = urls.indexOf(responseUrl);
                    if(ret[index]) {
                        ret[index] += count;
                    } else {
                        ret[index] = count;
                    }
                });
            }
            callback(ret);
        }
    });
}


initInfiniteScroll = function(){
    var con = $('.more-link');
    var newsList = con.parent();
    var a =con.find('a');
    a.click(function(){
        a.off('click');
        a.text('Ładuję...');

        var loading = false;
        var page = 1;
        $(window).scroll(function(){
            if(!loading){
                if ($(window).scrollTop() > $(document).height() - $(window).height() - 500){
                    loading = true;
                    loadContent();
                }
            }
        });

        function loadContent(){
            $.get('/more?page='+page, function(data){
                data = $(data);
                con.before(data);
                // initArticles(dom.filter('article'));

                fixLeads(data[0]);
                fixMobileLeads(data);
                initFbLikes(data);

                page++;
                loading = false;
            });
        }
        loadContent();
        return false;
    });
}


initProfileInfiniteScroll = function(con, fix){
    var a = con.find('a');
    a.click(function(){
        a.off('click');
        a.text('Ładuję...');
        var loading = false;
        var page = 2;
        $(window).scroll(function(){
            if(!loading){
                if ($(window).scrollTop() > $(document).height() - $(window).height() - 500){
                    loading = true;
                    loadContent();
                }
            }
        });

        function loadContent(){
            var url = con.data('url') + '?page=' + page;
            $.get(url, function(data){
                if(data !== "") {
                    data = $(data);
                    con.before(data);


                    if(fix){
                        fixLeads(data[0]);
                        fixMobileLeads(data);
                        initFbLikes(data);
                    }

                    page++;
                    loading = false;
                } else {
                    con.hide();
                }
            });
        }
        loadContent();
        return false;
    });
}


var getFingerprint = window.getFingerprint = function(){
    let loadScript = function(src) {
        console.log('loading script');
        return new Promise(function (resolve, reject) {
            var s;
            s = document.createElement('script');
            s.src = src;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }



    return new Promise(function(resolve) {
        let getFromApi = function(){
            FingerprintJS.load().then(fp => {
                fp.get().then(result => {
                    const visitorId = result.visitorId;
                    resolve(visitorId);
                });
            });
        }

        if(! window.FingerprintJS) {
            loadScript('https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@3/dist/fp.min.js').then(getFromApi);
        } else {
            getFromApi();
        }
    });

};



var initPolls = window.initPolls = function() {





    var initialTime = new Date().getTime();

    $('.poll').each(function(){
        var poll = $(this);
        poll.find('.answer-li').click(function(){
            var answer = $(this);
            var id = $(this).data('id');
            var pollId = poll.data('id');
            var timeDifference = new Date().getTime() - initialTime;

            showResult();
            getFingerprint().then((fingerprint) => {
                let data = {
                    p1: fingerprint + ((new Date()).getDate() ),
                    p2: timeDifference,
                };
                $.post('/polls/' + pollId +'/vote/' + id, data);
            });




        });
        poll.find('.show-result').click(showResult);

        function showResult(){
            poll.find('.answer-list').addClass('hide');
            var result = poll.find('.result-list');
            result.removeClass('hide');
            setTimeout(function(){
                result.addClass('animate');
            });
            return false;
        }


    })
}

var initPollsSize = window.initPollsSize = function() {

    if(document.fonts){
        document.fonts.ready.then(doIt);
    } else {
        document.addEventListener('DOMContentLoaded', doIt);
    }

    function doIt() {
        setTimeout(function(){
            $('.poll').each(function(){
                var poll = $(this);
                var news = poll.closest('.container').find('.big-horizontal');
                var newsH = news.height();
                var conH  = news.find('.article-con').outerHeight() - 10 ;
                var pollHeight = newsH - conH;
                var percent = pollHeight * 100 / 320;
                poll.find('.img-con').css('padding-bottom', percent + '%');

            });
        },10)
    }

}







var initUserBox = function() {
    var boxs = $('.order-box');
    var links = $('#user-menu .main-a');
    links.click(function(e){
        var link = $(this);
        var box = $(link.data('target'));

        if(! box.is(':visible')){
            toggle(links.filter('.hover'));
            $('body').one('click', function(){
                toggle(links.filter('.hover'));
            });
            setTimeout(function(){
                var firstInput = box.find('input:first').get(0);
                if(firstInput){
                    firstInput.focus();
                }
            })
        }
        toggle(link);
        e.stopPropagation();
        return false;
    });
    var toggle = function(link){
        var box = $(link.data('target'));
        var url = link.data('href');
        if(url){
            $.get(url,function(data){
                box.html(data);
            });
        }
        box.toggle();
        link.find('.box-arrow').toggle();
        link.toggleClass('hover');
    }
    boxs.click(function(e){
        e.stopPropagation();
    });
}
initUserBox();


$('#search-link').click(function(){
    var form = $('#search-form').show();
    form.click(function(e){
        e.stopPropagation();
    });
    form.find('input').focus();
    $('body').one('click',function(){
        form.hide();
    });
    return false;
});


initMobileNews = function(){
    if(! isMobile()){
        return;
    }
    $('#third-big-article').insertBefore($('#second-articles-list .article' ).eq(2));
    fixMobileLeads($('body'));
}

fixMobileLeads = function(con){
    if(! isMobile()){
        return;
    }
    var acticles = con.find('.article');
    acticles.each(function(i, art){
        art = $(art);

        var isSmall = art.hasClass('mobile-small');
        var totalLines = 7    ;
        var lineHeight  = isSmall ? 24.0 : 26.45;
        var headerLines = Math.round(art.find('h2')[0].clientHeight / lineHeight);

        var leadLines = totalLines - headerLines ;
        if(leadLines < 2){
            leadLines = 2;
        }
        art.find('p').shave(21 * leadLines);
    })

}



// WEBPACK FOOTER //
// ./Resources/assets/js/main.js